@use '~@frontrow/console/css/variables.scss';

@forward '~@frontrow/console/css/variables.scss';

.schoolAdminFormContainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: variables.$std-margin-md;
}

.schoolAdminDetailsContainer,
.schoolAdminAssessmentsContainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
}

.schoolAdminFullFieldContainer {
  width: 100%;
}

.schoolAdminGenericFieldContainer {
  width: 50%;
}

.schoolAdminFormButtonContainer {
  text-align: right;
}

.schoolAdminFormCancel {
  margin-right: variables.$std-margin-sm;
}

.schoolAdminConfirmCheckBoxContainer {
  display: flex;

  input {
    margin-left: variables.$std-margin-xxs;
  }
}

.deprecatedField {
  font-style: italic;
}

.invalidField {
  outline-color: variables.$theme-danger;
}
